import { map } from "lodash/fp";
import { DateTime } from "luxon";
import DateRangePicker, {
  DateRangePickerProps,
  DateRange as DatePickerRange,
} from "rsuite/DateRangePicker";

import type { CustomDateRange } from "@app/analytics/types";

import { CustomPickerContainer } from "./styles";

import "rsuite/dist/rsuite-no-reset.min.css";
import "./custom_date_range_picker.css";

const { combine, allowedMaxDays, allowedRange } = DateRangePicker;

// don't allow selecting dates before 2020; we don't have any data before then anyway...
const ALLOWED_RANGE_START = DateTime.fromISO(
  "2020-01-02T00:00:00.000-00:00"
).startOf("year");

const ALLOWED_RANGE_END = DateTime.now();

const YEARS_BETWEEN_NOW_AND_RANGE_START = Math.ceil(
  ALLOWED_RANGE_END.diff(ALLOWED_RANGE_START).as("years")
);

export interface CustomDateRangePickerProps {
  onChange: (range: CustomDateRange) => void;
  onClose: () => void;
  value?: CustomDateRange;
}

const renderMonthTitle = (date: Date) =>
  DateTime.fromJSDate(date).toLocaleString({
    month: "long",
    year: "numeric",
  });

const CustomDateRangePicker = ({
  onChange,
  onClose,
  value,
}: CustomDateRangePickerProps) => {
  const handleChange = (values: DateRangePickerProps["value"]) => {
    if (values) {
      const [startDate, endDate] = values;
      onChange([DateTime.fromJSDate(startDate), DateTime.fromJSDate(endDate)]);
    }
  };

  const pickerValue = map((date) => date.toJSDate(), value) as DatePickerRange;

  return (
    <CustomPickerContainer>
      <DateRangePicker
        appearance="subtle"
        format="MM/dd/yyyy"
        character=" - "
        defaultOpen
        ranges={[]}
        onChange={handleChange}
        onExit={onClose}
        limitStartYear={YEARS_BETWEEN_NOW_AND_RANGE_START}
        limitEndYear={1}
        placement="bottomEnd"
        preventOverflow
        renderTitle={renderMonthTitle}
        showOneCalendar
        shouldDisableDate={combine(
          allowedMaxDays(366),
          allowedRange(
            ALLOWED_RANGE_START.toJSDate(),
            ALLOWED_RANGE_END.toJSDate()
          )
        )}
        value={pickerValue}
      />
    </CustomPickerContainer>
  );
};

export default CustomDateRangePicker;
